import { Link, useLocation } from "react-router-dom";
import { hasAdminAccess, services } from "../../reducers/authSlice";
import { useEffect, useState } from "react";
import { Service } from "../../models/Service";
import { useAppSelector } from "../../app/hooks";

const NavigationBar = () => {
  const isAdmin = useAppSelector(hasAdminAccess);

  const [path, setPath] = useState("");
  const location = useLocation();

  const availableServices:Service[] = useAppSelector(services);

  useEffect(() => {
    //route change detected
    const search = window.location.pathname;
    const url = search?.split("/");
    const pathName = url[1] === "" ? "" : url[1];
    setPath(pathName);

  }, [location]);

  return (
    <div>
        <div className="sidebar-nav">
          <ul className="navbar">
            <li className={path === "" ? "active" : ""} data-testid="btnHomePage">
              <Link to="/">
                {" "}
                <i className="fi fi-rr-home icon" />
                <span className="label">
                  <span>Homepage</span>
                </span>
              </Link>
            </li>
            <li className={path === "myAccount" ? "active" : ""}
            data-testid="btnMyAccountPage"
            >
              <Link to="/myAccount">
                {" "}
                <i className="fi fi-br-user-gear"></i>
                <span className="label">
                  <span>My Account</span>
                </span>
              </Link>
            </li>

            <li className={path === "companyAdmin" ? "active" : ""} 
            data-testid="btnCompanyAdminPage"
            >
              <Link to="/companyAdmin">
                <i className="fi fi-bs-hotel"></i>
                <span className="label">
                  <span>Company Administrators</span>
                </span>
              </Link>
            </li>
            <li className={path === "myServices" ? "active nav-item-submenu" : "nav-item-submenu"}
            data-testid="btnMyServicesPage"
            >
              <Link to="/myServices">
                <i className="fi fi-rr-browser"></i>
              </Link>
              <ul className="nav nav-group-sub">
                {
                  availableServices &&
                    availableServices.map(s => {
                      return (
                        <li key={s.serviceCode} className="nav-item">
                          <a rel="noreferrer" target="_blank" className="nav-link" href={s.serviceUrl}>{s.name}</a>
                        </li>
                      )
                    })
                }
              </ul>
            </li>
            {isAdmin ? (
              <li className={path === "userManagement" ? "active" : ""}
              data-testid="btnUserMngtPage"
              >
                <Link to="/userManagement" data-testid="lnkUserMngtPage">
                  <i className="fi fi-ss-users"></i>
                  <span className="label">
                    <span>User Management</span>
                  </span>
                </Link>
              </li>
            ) : null}
          </ul>
        </div>

    </div>
    
  );
};

export default NavigationBar;
